import PropTypes from 'prop-types';
import React from 'react';
import PropertyDescriptionView from './PropertyDescriptionView';
import PropertyDescriptionForm from './PropertyDescriptionForm';


class PropertyDescription extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    console.log('handle submit...', values);
    const payload = { description: values };
    this.props.editHotel(this.props.hotel.id, payload);
    this.handleClose();
  }
  render() {
    if (this.state.isEditing) {
      return (
        <PropertyDescriptionForm
          {...this.props}
          onSubmit={this.handleSubmit}
          content={this.props.hotel.description}
          handleClose={this.handleClose}
        />);
    }
    return (
      <PropertyDescriptionView {...this.props} handleEdit={this.handleEdit} />
    );
  }
}
PropertyDescription.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
};

export default PropertyDescription;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDescription.js